<template>
	<div>
		<p class="pb-3">
			{{label}}
		</p>
		<vs-input :disabled="disabled" class="w-full" placeholder="Ingrese el texto" v-model.trim="answerSend"/>
	</div>
</template>

<script type="text/javascript">
	export default {
		props: {
			label: {
				type: String,
				required: false,
				default: 'Descripción'
			},
			answer: {
				type: String,
				required: false,
				default: ''
			},
			disabled: {
				type: Boolean,
				required: false,
				default: false
			}
		},
		data() {
			return {
				value: ''
			}
		},		
		computed: {
			answerSend: {
				get() {					
					return this.answer;
				},
				set(value) {
					this.$emit('input', value)
				}
			}
		}
		
	}
	
</script>